import { render, staticRenderFns } from "./exhibition-info-carApply.vue?vue&type=template&id=f2b19ea6&scoped=true&"
import script from "./exhibition-info-carApply.vue?vue&type=script&lang=js&"
export * from "./exhibition-info-carApply.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-info-carApply.vue?vue&type=style&index=0&id=f2b19ea6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b19ea6",
  null
  
)

export default component.exports